import { useFormDialogContext } from '@react-admin/ra-form-layout';
import { useCallback } from 'react';
import { useNotify, useRedirect } from 'react-admin';

import { PostB2bArbitrageRequestEndpoint } from '@Common/types/bo/review_requests/b2b_arbitrage';

import {
  ArbitrageFormData,
  buildArbitrageBody,
} from '@sh4res/bo-common/components/B2bArbitrage/buildArbitrageBody';
import { useArbitrageErrorMessage } from '@sh4res/bo-common/components/B2bArbitrage/useArbitrageErrorMessage';
import { useCreatePromise } from '@sh4res/bo-common/hooks';

// The arbitrage is only requested: it is created once another operator approves the request.
// Review requests only exist in the internal BO, the only one offering the arbitrage.
export const useArbitrageCreate = () => {
  const notify = useNotify();
  const getArbitrageErrorMessage = useArbitrageErrorMessage();
  const redirect = useRedirect();
  const { close } = useFormDialogContext();
  const [createArbitrageRequest] = useCreatePromise<
    PostB2bArbitrageRequestEndpoint['Client']['RequestBody'],
    PostB2bArbitrageRequestEndpoint['Client']['ResponseBody']
  >();

  return useCallback(
    async (values: ArbitrageFormData) => {
      let created: PostB2bArbitrageRequestEndpoint['Client']['ResponseBody'];
      try {
        created = await createArbitrageRequest('b2b/review_requests/arbitrage', {
          data: { data: buildArbitrageBody(values), reason: values.reason ?? '' },
        });
      } catch (error) {
        notify('resources.bo_common.b2b.arbitrage_create.actions.failure', {
          type: 'error',
          messageArgs: { error: getArbitrageErrorMessage(error) },
          multiLine: true,
        });
        return;
      }
      close();
      notify('resources.bo_common.b2b.arbitrage_create.actions.success', { type: 'info' });
      redirect('show', 'b2b/review_requests', created.id);
    },
    [createArbitrageRequest, notify, getArbitrageErrorMessage, redirect, close],
  );
};
